$(document).ready(function() {
	var count = 0;

    
	$('#right-arrow').click(function() {
		$('#productCarousel' + (count % 3)).removeClass('active');
		count++;
		$('#productCarousel' + (count % 3)).addClass('active');
	})

	$('#left-arrow').click(function() {
		$('#productCarousel' + (count % 3)).removeClass('active');
		count--;
		if (count < 0) { count = 2};
		$('#productCarousel' + (count % 3)).addClass('active');
	})
	
});